import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/pages/Index'
import OrderDetail from '@/pages/OrderDetail'
import Address from '@/pages/Address'
import OrderList from '@/pages/OrderList'
import OrderSuccess  from '@/pages/OrderSuccess'
import PaySuccess from '@/pages/PaySuccess'
import AddressConfirm from '@/pages/AddressConfirm'
Vue.use(Router)
let rootPath = "/"
export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      meta:{
        requireAuth:true
      },
      component: Index
    },    
    {
      path: rootPath+'OrderDetail',
      name: 'OrderDetail',
      component: OrderDetail
    }
    ,
    {
      path: rootPath+'Address/:order_id?',
      name: 'Address',
      component: Address
    }    
    ,
    {
      path: rootPath+'OrderList',
      name: 'OrderList',
      component: OrderList
    }
    ,
    {
      path: rootPath+'OrderSuccess',
      name: 'OrderSuccess',
      component: OrderSuccess
    }
    ,
    {
      path: rootPath+'PaySuccess',
      name: 'PaySuccess',
      component: PaySuccess
    }
    ,
    {
      path: rootPath+'AddressConfirm',
      name: 'AddressConfirm',
      component: AddressConfirm
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js